var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-dj",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-40 0h682.7v512H-40z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(37.5) scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0c0",
    d: "M-40 0h768v512H-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M-40 0h768v256H-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffefe",
    d: "m-40 0 382.7 255.7L-40 511V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M119.8 292 89 270l-30.7 22.4L69.7 256l-30.6-22.5 37.9-.3 11.7-36.3 12 36.2h37.9l-30.5 22.7 11.7 36.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj);
export default __webpack_public_path__ + "static/media/dj.6246a301207a9902a5571685ce526fe0.svg";
export { ForwardRef as ReactComponent };